export default function getMatchEventTime(timeStr) {
  let eventTime = '';
  const eventTimeParts = timeStr.split(':');
  if (eventTimeParts.length > 2) {
    // e.g. 45:00 +2:00, 90:00 +6:00
    const addedTime = parseInt(eventTimeParts[1].split(' ')[1], 10);
    eventTime = `${parseInt(eventTimeParts[0], 10) + addedTime}'`;
  } else {
    // e.g. 56:00, 90:00
    eventTime = `${eventTimeParts[0]}'`;
  }
  return eventTime;
}
